import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  errors: null,
  AuthData: null,
  loader: false,
  success: false,
};

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.LOGIN_REQUEST:
      return { ...state, loader: true, errors: null };

    case ACTIONS_TYPES.LOGIN_SUCCESS:
      return { ...state, AuthData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.LOGIN_FAILED:
      return { ...state, loader: false, errors: action.payload };

    case ACTIONS_TYPES.LOGIN_RESET:
      return { ...state, success: false, errors: null }
    case ACTIONS_TYPES.LOGOUT_REQUEST:
      return { ...initialState  };

    default:
      return state;
  }
}